import React from 'react';
import { Icon } from '@iconify/react';
import { AppAlert } from '../ui';
import { normalizePlanDeComWarnings } from '../../utils/planDeComWarnings';

const PlanDeComWarningsAlert = ({
  warnings,
  title = 'Points à vérifier',
  className = 'mb-3',
  compact = false,
}) => {
  const items = normalizePlanDeComWarnings(warnings);
  if (items.length === 0) return null;

  return (
    <AppAlert variant="warning" className={`kkp-pdc-warnings ${className}`.trim()}>
      <div className="d-flex align-items-start gap-2 mb-2">
        <Icon icon="mdi:alert-circle-outline" className="fs-5 flex-shrink-0 mt-1" />
        <strong className="mb-0">{title}</strong>
      </div>
      <ul className="kkp-pdc-warnings__list mb-0">
        {items.map((w) => (
          <li key={w.id} className="kkp-pdc-warnings__item">
            <div className="fw-semibold">{w.title}</div>
            {w.message && (
              <p className={compact || !w.hint ? 'mb-0' : 'mb-1'}>{w.message}</p>
            )}
            {!compact && w.hint && (
              <p className="kkp-pdc-warnings__hint mb-0">
                <Icon icon="mdi:arrow-right" className="me-1" />
                {w.hint}
              </p>
            )}
          </li>
        ))}
      </ul>
    </AppAlert>
  );
};

export default PlanDeComWarningsAlert;
